"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const scale_1 = require("../../utils/scale");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const User_1 = __importDefault(require("../../networking/apis/User"));
const helpler_1 = require("../../utils/helpler");
const InputMultiField_1 = __importDefault(require("../input/InputMultiField"));
const LoadingLogin_1 = __importDefault(require("../loading/LoadingLogin"));
const ImagePickers_1 = __importDefault(require("../picker/ImagePickers"));
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalReportReason = (props) => {
    const { visible, onClose, onNext, violation, checked, typeRepost, idRepost } = props;
    const [text, setText] = (0, react_1.useState)('');
    const [formDataImage, setFormDataImage] = (0, react_1.useState)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    // console.log(data, checked);
    // const handleCheck = (itemId: number) => {
    //   if (checked.includes(itemId)) {
    //     setChecked(checked.filter((id) => id !== itemId));
    //   } else {
    //     setChecked([...checked, itemId]);
    //   }
    // };
    const OnCofirm = () => {
        setLoading(true);
        if (typeRepost == 'deleteArticle') {
            repostArticle();
        }
        else if (typeRepost == 'deleteArticleComment') {
            repostArticleComment();
        }
        else if (typeRepost == 'deleteComment' || typeRepost == 'deletePost') {
            repostTweet();
        }
        else if (typeRepost == 'USER') {
            repostUser();
        }
    };
    const checkFormdata = () => {
        const data = new FormData();
        data.append('type', `${checked}`);
        if (violation != 0) {
            data.append('violation_of_rights', `${violation}`);
        }
        data.append('reason', `${text}`);
        if (formDataImage?.length > 0) {
            data.append(' image', formDataImage[0]);
        }
        return { formdata: data, id: idRepost };
    };
    const repostUser = async () => {
        await User_1.default?.repostUser(checkFormdata())
            .then((_res) => {
            onNext();
            setText('');
            setFormDataImage([]);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const repostArticle = async () => {
        await User_1.default?.repostArticle(checkFormdata())
            .then((_res) => {
            onNext();
            setText('');
            setFormDataImage([]);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const repostArticleComment = async () => {
        await User_1.default.repostArticleComment(checkFormdata())
            .then((_res) => {
            onNext();
            setText('');
            setFormDataImage([]);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const repostTweet = async () => {
        await User_1.default?.repostTweet(checkFormdata())
            .then((_res) => {
            onNext();
            setText('');
            setFormDataImage([]);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const formListImage = (data) => {
        setFormDataImage(data);
    };
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.Pressable, { style: {
                flex: 1,
                backgroundColor: Colors_1.default.textHeaderOpacity60,
                justifyContent: 'center',
                alignItems: 'center',
            } },
            react_1.default.createElement(react_native_1.View, { style: {
                    backgroundColor: '#FEFEFE',
                    width: (0, scale_1.scale)(343),
                    borderRadius: (0, scale_1.scale)(12),
                    overflow: 'hidden',
                } },
                react_1.default.createElement(react_native_1.View, { style: {
                        paddingHorizontal: (0, scale_1.scale)(16),
                        paddingVertical: (0, scale_1.scale)(20),
                        borderBottomColor: '#E0E0E0',
                        //   borderBottomWidth: 1,
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.textHeader }, "\u901A\u5831\u3059\u308B\u7406\u7531\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"),
                    react_1.default.createElement(InputMultiField_1.default, { style: styles.input, isRequire: true, placeholder: "\u901A\u5831\u7406\u7531\u3092\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044", placeholderTextColor: '#C8C8C8', label: '通報理由', onRightIconLabelPress: () => {
                            // setVisibleEmail(!visibleEmail);
                        }, value: text, onChangeText: (text) => {
                            setText(text);
                            // setErrorEmail("");
                        }, onBlur: () => {
                            setText(text.trim());
                        }, maxLength: 1000, errorText: errorMessage }),
                    react_1.default.createElement(react_native_1.View, { style: { paddingVertical: (0, scale_1.scale)(16) } },
                        react_1.default.createElement(CustomText_1.default, { style: styles.textImageLabel }, "\u53C2\u8003\u753B\u50CF"),
                        react_1.default.createElement(ImagePickers_1.default, { formDataImage: (data) => formListImage(data) })),
                    react_1.default.createElement(CustomText_1.default, { style: styles.textDetail }, "\u4E0D\u9069\u5207\u3068\u3057\u3066\u901A\u5831\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3084\u30E6\u30FC\u30B6\u30FC\u306F\u904B\u55B6\u306E\u30B9\u30BF\u30C3\u30D5\u304C\u78BA\u8A8D\u3057\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\u306B\u9055\u53CD\u3057\u3066\u3044\u306A\u3044\u304B\u3069\u3046\u304B\u5224\u65AD\u3057\u3066\u3044\u307E\u3059\u3002\u6DF1\u523B\u306A\u9055\u53CD\u306E\u5834\u5408\u3084\u9055\u53CD\u304C\u7E70\u308A\u8FD4\u3055\u308C\u305F\u5834\u5408\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u505C\u6B62\u3055\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002")),
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', width: '100%' } },
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.btn, onPress: () => {
                            onClose();
                            setText('');
                            setFormDataImage([]);
                        } },
                        react_1.default.createElement(CustomText_1.default, { style: styles.textBtn }, "\u30AD\u30E3\u30F3\u30BB\u30EB")),
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.btn, disabled: !text, onPress: () => {
                            const data = { formDataImage: formDataImage, text: text };
                            OnCofirm();
                        }, activeOpacity: 1 },
                        react_1.default.createElement(CustomText_1.default, { weight: '600', style: [styles.textBtn, !text && { color: '#7C7C7C' }] }, "\u901A\u5831"))),
                isLoading && react_1.default.createElement(LoadingLogin_1.default, null)))));
};
const styles = react_native_1.StyleSheet.create({
    mainNoti: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors_1.default.textHeaderOpacity60,
    },
    checkboxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: (0, scale_1.scale)(16),
    },
    circle: {
        height: 20,
        width: 20,
        borderRadius: 10,
        marginRight: 10,
        borderWidth: 1,
        borderColor: '#C8C8C8',
        justifyContent: 'center',
        alignItems: 'center',
    },
    checkedCircle: {
        backgroundColor: '#007AFF',
        width: 10,
        height: 10,
        borderRadius: 5,
    },
    btn: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: '#DDDDDD',
        height: (0, scale_1.scale)(48),
    },
    textBtn: {
        color: '#007AFF',
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
    },
    vBtn: {
        height: (0, scale_1.scale)(62),
        width: '100%',
        borderTopWidth: 1,
        borderTopColor: '#CCCCCC',
        flexDirection: 'row',
    },
    textHeader: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        fontWeight: '600',
        color: '#292A33',
        textAlign: 'center',
        marginBottom: (0, scale_1.scale)(16),
    },
    textCheck: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        fontWeight: '300',
        color: '#292A33',
    },
    textImageLabel: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
        marginBottom: (0, scale_1.scale)(8),
    },
    textDetail: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#7C7C7C',
    },
    input: {
        width: (0, scale_1.scale)(311),
    },
    err: {
        color: '#FF0000',
        fontSize: (0, scale_1.moderateScale)(13),
        marginBottom: (0, scale_1.scale)(10),
    },
});
exports.default = ModalReportReason;
